import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Breadcrumbs from '@bit/knotchinc.web-react-components.breadcrumbs';
import { Link } from 'react-router-dom';

import BREADCRUMB_TREE from './breadcrumbTree.json';
import BREADCRUMB_MAP from './breadcrumbMap.js';

export class BreadcrumbsContainer extends Component {
  render() {
    const { appState, history } = this.props;

    return (
      <Breadcrumbs as={Link} linkComponent={Link} appState={appState} breadcrumbTree={BREADCRUMB_TREE} breadcrumbMap={BREADCRUMB_MAP(history)} />
    );
  }
}

function mapStateToProps({
  Home,
  Content,
  Library,
  SearchFeed,
  Insights,
  BrandProfile,
  PublisherProfile,
  PartnershipProfile,
  Settings,
  Notifications,
  }) {
  return {
    appState: {
      home: Home.followedEntitiesList,
      contentView: Content.contentMetadata,
      competitorContentFeed: Library.competitorContentList,
      savedContentFeed: Library.savedContentList,
      subscribedContentFeed: Library.subscribedContentList,
      searchFeed: SearchFeed.contentList,
      brandPaidContentFeed: BrandProfile.paidContentList,
      brandOwnedContentFeed: BrandProfile.ownedContentList,
      publisherPaidContentFeed: PublisherProfile.paidContentList,
      brandInsightsView: BrandProfile.metadata.fetched && (Insights.content[BrandProfile.metadata.data.public_id] || {}),
      publisherInsightsView: PublisherProfile.metadata.fetched && (Insights.content[PublisherProfile.metadata.data.public_id] || {}),
      partnershipView: PartnershipProfile.metadata.fetched && { ...PartnershipProfile, status: 'success' },
      brandView: BrandProfile.metadata,
      publisherView: PublisherProfile.metadata,
      settingsProfileView: { status: Settings.profileMounted ? 'success' : false },
      settingsCompetitorsView: Settings.competitorsList,
      alertSettings: Notifications.alertSettings,
    },
  };
}

export default withRouter(connect(mapStateToProps)(BreadcrumbsContainer));
